import { ServiceComboDisplaySettingsModel } from "@/Administration/Models/Settings/ServiceComboDisplaySettingsModel";
import { CalendarDisplay } from "@/Appointments/Models/Settings/CalendarDisplay";
import { NoticeBoardSearchSettings } from "@/Appointments/Models/Settings/NoticeBoardSearchSettings";
import { PADisplaySettings } from "@/Appointments/Models/Settings/PADisplaySettings";
import { PAListDisplaySettings } from "@/Appointments/Models/Settings/PAListDisplaySettings";
import { BillingClaimStatusFilterSettings } from "@/Billing/Models/Settings/BillingClaimStatusFilterSettings";
import { PayableInboxFilterSettings } from "@/Billing/Models/Settings/PayableInboxFilterSettings";
import { UserSettingsConfig } from "@/Common/Models/Settings/UserSettingsConfig";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { GridDisplaySettings } from "@/Common/Models/UI/Tables/GridDisplaySettings";
import { IPortalCommunicationInboxFilterSetting, IPortalCommunicationSentFilterSetting } from "@/Communications/Api/Dto/PortalCommunication/IPortalCommunicationFilterSettings";
import { ExternalMessageInboxSearchSettings } from "@/Communications/Models/Settings/ExternalMessageInboxSearchSettings";
import { MessageSearchSettings } from "@/Communications/Models/Settings/MessageSearchSettings";
import { RecallSearchSettings } from "@/Communications/Models/Settings/RecallSearchSettings";
import { TaskSearchSettings } from "@/Communications/Models/Settings/TaskSearchSettings";
import { DocumentSearchSettings } from "@/Documents/Models/Settings/DocumentSearchSettings";
import { InboundFaxMailboxFilterSettingsModel } from "@/Documents/Models/Settings/InboundFaxMailboxFilterSettings";
import { InboundFaxTriageFormSettingsModel } from "@/Documents/Models/Settings/InboundFaxTriageFormSettings";
import { ExportableFilePopupSettings } from "@/ExportableFile/Models/Settings/ExportableFilePopupSettings";
import { LabSettings } from "@/Labs/Models/Settings/LabSettings";
import { WorkerClaimFormSearchSettings } from "@/Modules/Cnesst/Models/Portfolio/UI/WorkerClaimFormSearchSettings";
import { MedicalSummaryPanelSettings } from "@/Patient/Models/Settings/MedicalSummaryPanelSettings";
import { NotesFilterSettings } from "@/Patient/Models/Settings/NotesFilterSettings";
import { NoteStreamlineSettings } from "@/Patient/Models/Settings/NoteStreamlineSettings";
import { PatientProfileRequestModalSettings } from "@/Patient/Models/Settings/PatientProfileRequestModalSettings";
import { SummaryConfigurationSettings } from "@/Patient/Models/Settings/SummaryConfigurationSettings";
import { IPharmacyOrdersFilterSettings } from "@/PharmacyOrders/Api/Dto/IPharmacyOrdersFilterSettings";
import { MedicalRequestsInboxSettings } from "@/Portfolio/Models/Settings/MedicalRequestsInboxSettings";
import { PopulationBasedFundingPortfolioFilterSettings } from "@/Portfolio/Models/Settings/PopulationBasedFundingTableFilterSettings";
import { PreventiveActivitiesSearchSettings } from "@/Portfolio/Models/Settings/PreventiveActivitiesSearchSettings";
import { PreventiveRecallListSearchSettings } from "@/Portfolio/Models/Settings/PreventiveRecallListSearchSettings";
import { SentFaxSearchSettings } from "@/Portfolio/Models/Settings/SentFaxSearchSettings";
import { PrescriptionRenewalSettings } from "@/PrescriptionRenewals/Models/Settings/PrescriptionRenewalSettings";

class UserSettings {
    public LabSettings: LabSettings;
    public CalendarDisplay: CalendarDisplay;
    public ServiceComboDisplay: ServiceComboDisplaySettingsModel;
    public DocumentSearchSettings: DocumentSearchSettings;
    public PatientDocumentSearchSettings: DocumentSearchSettings;
    public PAListDisplaySettings: PAListDisplaySettings;
    public PADisplay: PADisplaySettings;
    public MessageSearchSettings: MessageSearchSettings;
    public TaskSearchSettings: TaskSearchSettings;
    public RecallSearchSettings: RecallSearchSettings;
    public DefaultSiteId: string;
    public GridsDisplaySettings: KeyValuePair<string, GridDisplaySettings>[];
    public WorkerClaimFormSearchSettings: WorkerClaimFormSearchSettings;
    public ExternalMessageInboxSearchSettings: ExternalMessageInboxSearchSettings;
    public NoticeBoardSearchSettings: NoticeBoardSearchSettings;
    public UserSettingsConfig: UserSettingsConfig;
    public ConsultationRequestsSearchSettings: MedicalRequestsInboxSettings;
    public RequestsSearchSettings: MedicalRequestsInboxSettings;
    public PreventiveActivitiesSearchSettings: PreventiveActivitiesSearchSettings;
    public PreventiveRecallListSearchSettings: PreventiveRecallListSearchSettings;
    public InboundFaxMailboxFilterSettings: InboundFaxMailboxFilterSettingsModel;
    public InboundFaxTriageFormSettings: InboundFaxTriageFormSettingsModel;
    public MedicalNoteMedicalSummaryPanelSettings: MedicalSummaryPanelSettings;
    public LabViewMedicalSummaryPanelSettings: MedicalSummaryPanelSettings;
    public PrescriptionRenewalFilterSettings: PrescriptionRenewalSettings;
    public PortfolioPopulationBasedFundingFilter: PopulationBasedFundingPortfolioFilterSettings;
    public BillingClaimStatusReportSettings: BillingClaimStatusFilterSettings;
    public PayableInboxFilterSettings: PayableInboxFilterSettings;
    public NotesFilterSettings: NotesFilterSettings;
    public SummaryConfigurationSettings: SummaryConfigurationSettings;
    public ExportableFilePopup: ExportableFilePopupSettings;
    public ExamRequestModal: PatientProfileRequestModalSettings;
    public ConsultationRequestModal: PatientProfileRequestModalSettings;
    public PharmacyOrdersFilterSettings: IPharmacyOrdersFilterSettings;
    public PharmacyOrdersMedicalSummaryPanelSettings: MedicalSummaryPanelSettings;
    public PortalCommunicationInboxFilterSetting: IPortalCommunicationInboxFilterSetting;
    public PortalCommunicationSentFilterSetting: IPortalCommunicationSentFilterSetting;
    public PortalCommunicationFlaggedFilterSetting: IPortalCommunicationInboxFilterSetting;
    public PortalCommunicationArchivedFilterSetting: IPortalCommunicationInboxFilterSetting;
    public PortfolioFailedFaxesFilterSetting: SentFaxSearchSettings;
    public PortfolioSentFaxSearchSettings: SentFaxSearchSettings;
    public NoteStreamlineSettings: NoteStreamlineSettings;
    public IsInstantMessagingSoundNotificationDisabled?: boolean;

    constructor(fields?: Partial<UserSettings>) {
        Object.assign(this, fields);
    }
}

export { UserSettings };
